/** @file Context menu in a portal at a screen point; closed when `at` is null. */
import { createPortal } from 'react-dom';
import { ContextMenuList } from './ContextMenuList';
import type { MenuItem } from './ContextMenuList';
import type { Point } from './logic/placeMenu';

/** Props of ContextMenu. */
export interface ContextMenuProps {
  /** Viewport position to open at (usually the contextmenu event's clientX/clientY); null = closed. */
  at: Point | null;
  items: readonly MenuItem[];
  /** Called with the chosen item's id; the menu then calls `onClose` itself. */
  onSelect: (id: string) => void;
  onClose: () => void;
  /** Already-translated accessible name of the menu. */
  label: string;
}

/** Keyboard: arrows, Home, End, Enter, Space, Escape; a click outside or a window blur closes it. */
export function ContextMenu({ at, items, onSelect, onClose, label }: ContextMenuProps) {
  if (at === null) return null;
  return createPortal(<ContextMenuList at={at} items={items} onSelect={onSelect} onClose={onClose} label={label} />, document.body);
}
